<style lang="scss">
.m1_sub-exam-reg-menu {
  .steps {
    margin: 44px auto;
    text-align: center;
  }
  .line {
    border-top: 3px solid #cccccc;
    width: 30px;
    margin: 4px 18px;
    display: inline-block;
  }
}
</style>
<template>
  <div class="m1_sub-exam-reg-menu">
    <div class="steps">
      <span :class="{'AEE-tc':menuIndex==order[0].index}">① {{order[0].text}}</span>
      <div class="line" v-if="order[1]"></div>
      <span :class="{'AEE-tc':menuIndex==order[1].index}" v-if="order[1]">② {{order[1].text}}</span>
      <div class="line" v-if="order[2]"></div>
      <span :class="{'AEE-tc':menuIndex==order[2].index}" v-if="order[2]">③ {{order[2].text}}</span>
      <span class="clear"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuIndex: {
      default: "0"
    }
  },
  computed: {
    order: function() {
      let data = [],
        examInfo = this.$store.state.examRegInfo.examRegInfo;
      if (examInfo == null) {
        return false;
      } else {
        if (examInfo.text_info_confs.length > 0) {
          data.push({
            text: "基本信息",
            index: 1
          });
        }
        if (examInfo.pic_info_confs.length > 0) {
          data.push({
            text: "照片信息",
            index: 2
          });
        }
        if (examInfo.file_info_confs.length > 0) {
          data.push({
            text: "文件上传",
            index: 3
          });
        }
        return data;
      }
    }
  }
};
</script>